/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";
var $protobuf
var $root
if(process.browser){
  $protobuf = require("protobufjs/light");

  $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
      .addJSON({
        com: {
          nested: {
            lawback: {
              nested: {
                push: {
                  nested: {
                    core: {
                      nested: {
                        pb: {
                          nested: {
                            Cmd: {
                              values: {
                                heartbeat: 0,
                                ack: 1,
                                ok: 2,
                                error: 3,
                                connect: 4,
                                connect_ok: 5,
                                test_connect: 6,
                                bind_user: 100,
                                unbind_user: 101,
                                gateway_push: 102,
                                chat_room_message: 103,
                                enter_chat_room: 104,
                                leave_chat_room: 105,
                                chat_room_user_state: 106
                              }
                            },
                            Ok: {
                              fields: {
                                cmd: {
                                  type: "int32",
                                  id: 1
                                },
                                code: {
                                  type: "int32",
                                  id: 2
                                },
                                msg: {
                                  type: "string",
                                  id: 3
                                },
                                data: {
                                  type: "string",
                                  id: 4
                                }
                              }
                            },
                            Error: {
                              fields: {
                                cmd: {
                                  type: "int32",
                                  id: 1
                                },
                                code: {
                                  type: "int32",
                                  id: 2
                                },
                                msg: {
                                  type: "string",
                                  id: 3
                                },
                                data: {
                                  type: "string",
                                  id: 4
                                }
                              }
                            },
                            Connect: {
                              fields: {
                                clientVersion: {
                                  type: "string",
                                  id: 1
                                },
                                deviceId: {
                                  type: "string",
                                  id: 2
                                },
                                osName: {
                                  type: "string",
                                  id: 3
                                },
                                osVersion: {
                                  type: "string",
                                  id: 4
                                },
                                heartbeat: {
                                  type: "int32",
                                  id: 5
                                }
                              }
                            },
                            ConnectOk: {
                              fields: {
                                sessionId: {
                                  type: "string",
                                  id: 1
                                },
                                heartbeat: {
                                  type: "int32",
                                  id: 2
                                },
                                expireTime: {
                                  type: "int64",
                                  id: 3
                                }
                              }
                            },
                            BindUser: {
                              fields: {
                                bid: {
                                  type: "string",
                                  id: 1
                                },
                                uid: {
                                  type: "string",
                                  id: 2
                                },
                                phone: {
                                  type: "string",
                                  id: 3
                                },
                                token: {
                                  type: "string",
                                  id: 4
                                }
                              }
                            },
                            UnBindUser: {
                              fields: {
                                bid: {
                                  type: "string",
                                  id: 1
                                },
                                uid: {
                                  type: "string",
                                  id: 2
                                }
                              }
                            },
                            GatewayPush: {
                              fields: {
                                id: {
                                  type: "int64",
                                  id: 1
                                },
                                uid: {
                                  type: "string",
                                  id: 2
                                },
                                content: {
                                  type: "string",
                                  id: 3
                                },
                                contentType: {
                                  type: "string",
                                  id: 4
                                },
                                clientType: {
                                  type: "int32",
                                  id: 5
                                },
                                contentKey: {
                                  type: "string",
                                  id: 6
                                },
                                ext: {
                                  type: "string",
                                  id: 7
                                }
                              }
                            },
                            ChatRoomMessage: {
                              fields: {
                                msgId: {
                                  type: "string",
                                  id: 1
                                },
                                roomId: {
                                  type: "int64",
                                  id: 2
                                },
                                fromUid: {
                                  type: "string",
                                  id: 3
                                },
                                fromName: {
                                  type: "string",
                                  id: 4
                                },
                                fromIcon: {
                                  type: "string",
                                  id: 5
                                },
                                msgType: {
                                  type: "string",
                                  id: 6
                                },
                                msg: {
                                  type: "string",
                                  id: 7
                                },
                                ext: {
                                  type: "string",
                                  id: 8
                                },
                                ts: {
                                  type: "int64",
                                  id: 9
                                },
                                operator: {
                                  type: "int32",
                                  id: 10
                                }
                              }
                            },
                            EnterChatRoom: {
                              fields: {
                                roomId: {
                                  type: "int64",
                                  id: 1
                                },
                                ext: {
                                  type: "string",
                                  id: 2
                                }
                              }
                            },
                            LeaveChatRoom: {
                              fields: {
                                roomId: {
                                  type: "int64",
                                  id: 1
                                },
                                ext: {
                                  type: "string",
                                  id: 2
                                }
                              }
                            },
                            ChatRoomUserState: {
                              fields: {
                                roomId: {
                                  type: "int64",
                                  id: 1
                                },
                                uid: {
                                  type: "string",
                                  id: 2
                                },
                                type: {
                                  type: "string",
                                  id: 3
                                },
                                ext: {
                                  type: "string",
                                  id: 4
                                }
                              }
                            },
                            TestConnect: {
                              fields: {
                                uid: {
                                  type: "string",
                                  id: 1
                                },
                                sessionId: {
                                  type: "string",
                                  id: 2
                                },
                                channelId: {
                                  type: "string",
                                  id: 3
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
}


module.exports = $root;
